import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MessageOutboxReducer } from '../reducers';

export const selectMessageOutboxFeature = createFeatureSelector<MessageOutboxReducer.DataState>(MessageOutboxReducer.featureName);

export const selectFeatureMessageOutbox = createSelector(selectMessageOutboxFeature, (state: MessageOutboxReducer.DataState) => state.detail);
